export const FB_WIDTH = 720;
export const FB_HEIGHT = 1280;
export const FB_BPP = 32;
export const FB_STRIDE = 2880;

export const PHYS_WIDTH = 1280;
export const PHYS_HEIGHT = 720;

const BTN_CELL = 196;
export const BTN_SIZE = 196;

const PAD_TOP = 0;
const PAD_BOTTOM = 4;
const PAD_LEFT = 17;
const PAD_RIGHT = 28;

const H_GAP = Math.floor(
  (PHYS_WIDTH - PAD_LEFT - PAD_RIGHT - 5 * BTN_CELL) / 4,
);
const V_GAP = Math.floor(
  (PHYS_HEIGHT - PAD_TOP - PAD_BOTTOM - 3 * BTN_CELL) / 2,
);

export interface ButtonDef {
  index: number;
  keyCode: number;
  keyName: string;
  row: number;
  col: number;
  x: number;
  y: number;
  width: number;
  height: number;
  isRect: boolean;
}

export interface D200Layout {
  buttons: ButtonDef[];
  physWidth: number;
  physHeight: number;
  fbWidth: number;
  fbHeight: number;
}

const BUTTON_DEFS: Array<{
  index: number;
  keyCode: number;
  keyName: string;
  row: number;
  col: number;
  isRect: boolean;
}> = [
  { index: 0, keyCode: 29, keyName: 'LCTRL', row: 0, col: 0, isRect: false },
  { index: 1, keyCode: 15, keyName: 'TAB', row: 0, col: 1, isRect: false },
  { index: 2, keyCode: 14, keyName: 'BKSP', row: 0, col: 2, isRect: false },
  { index: 3, keyCode: 13, keyName: 'EQUAL', row: 0, col: 3, isRect: false },
  { index: 4, keyCode: 12, keyName: 'MINUS', row: 0, col: 4, isRect: false },
  { index: 5, keyCode: 11, keyName: 'KEY_0', row: 1, col: 0, isRect: false },
  { index: 6, keyCode: 10, keyName: 'KEY_9', row: 1, col: 1, isRect: false },
  { index: 7, keyCode: 9, keyName: 'KEY_8', row: 1, col: 2, isRect: false },
  { index: 8, keyCode: 8, keyName: 'KEY_7', row: 1, col: 3, isRect: false },
  { index: 9, keyCode: 7, keyName: 'KEY_6', row: 1, col: 4, isRect: false },
  { index: 10, keyCode: 34, keyName: 'KEY_G', row: 2, col: 0, isRect: false },
  { index: 11, keyCode: 33, keyName: 'KEY_F', row: 2, col: 1, isRect: false },
  { index: 12, keyCode: 31, keyName: 'KEY_S', row: 2, col: 2, isRect: false },
  { index: 13, keyCode: 30, keyName: 'KEY_A', row: 2, col: 3, isRect: true },
];

function computeButton(def: (typeof BUTTON_DEFS)[number]): ButtonDef {
  const cellX = PAD_LEFT + def.col * (BTN_CELL + H_GAP);
  const cellY = PAD_TOP + def.row * (BTN_CELL + V_GAP);

  if (def.isRect) {
    return {
      ...def,
      x: cellX,
      y: cellY,
      width: PHYS_WIDTH - PAD_RIGHT - cellX,
      height: BTN_SIZE,
    };
  }

  return {
    ...def,
    x: cellX,
    y: cellY,
    width: BTN_SIZE,
    height: BTN_SIZE,
  };
}

export const BUTTON_COUNT = BUTTON_DEFS.length;

export function getLayout(): D200Layout {
  return {
    buttons: BUTTON_DEFS.map(computeButton),
    physWidth: PHYS_WIDTH,
    physHeight: PHYS_HEIGHT,
    fbWidth: FB_WIDTH,
    fbHeight: FB_HEIGHT,
  };
}
